import { Http } from '@/lib/http';
export class OnBoarderWorkflowService extends Http {
  constructor() {
    super();
    this.endpoint = 'onboarder/app/onboarder-work-flow/';
  }
  //Overall Application
  CreateApplication(payload) {
    return this.httpClient().post(`${this.endpoint}`, payload);
  }
  UpdateApplication(id, application) {
    return this.httpClient().patch(`${this.endpoint}${id}`, application);
  }
  GetAllApplications() {
    return this.httpClient().get(`${this.endpoint}`);
  }
  GetOneApplication(id) {
    return this.httpClient().get(`${this.endpoint}${id}`);
  }
  DeleteApplication(id) {
    return this.httpClient().delete(`${this.endpoint}${id}`);
  }
  UpdateAppVerificationStatus(id, data) {
    return this.httpClient().patch(`${this.endpoint}verify/${id}`, data);
  }
  GetAppsByStatus(status) {
    return this.httpClient().get(`${this.endpoint}progress/${status}`);
  }
  CreateAccount(data) {
    return this.httpClient().post(`${this.endpoint}create-account`, data);
  }

  /**
   *
   * @param {string} id - Id of the application to be printed
   * @param {object} options - Sections of the document to be printed
   */
  HtmlTemplate(id, options = {}) {
    return this.httpClient().patch(`${this.endpoint}${id}/pdf`, { options });
  }

  // Account Holder for the application
  CreateAccountHolder(applicationId, data) {
    return this.httpClient().post(
      `${this.endpoint}${applicationId}/account`,
      data
    );
  }
  UpdateAccountHolder(applicationId, accountId, data) {
    return this.httpClient().patch(
      `${this.endpoint}${applicationId}/account/${accountId}`,
      data
    );
  }
  DeleteNearestContact(applicationId, accountId) {
    return this.httpClient().delete(
      `${this.endpoint}${applicationId}/account/${accountId}/nearest-contact`
    );
  }
  DeleteAccountHolder(applicationId, accountId) {
    return this.httpClient().post(
      `${this.endpoint}${applicationId}/account/${accountId}`
    );
  }

  // Tel no for account holder
  CreateTelNo(applicationId, accountId, data) {
    return this.httpClient().post(
      `${this.endpoint}${applicationId}/account/${accountId}/telephone`,
      data
    );
  }
  UpdateTelNo(applicationId, accountId, telId, data) {
    return this.httpClient().patch(
      `${this.endpoint}${applicationId}/account/${accountId}/telephone/${telId}`,
      data
    );
  }
  DeleteTelNo(applicationId, accountId, telId) {
    return this.httpClient().delete(
      `${this.endpoint}${applicationId}/account/${accountId}/telephone/${telId}`
    );
  }

  // ID Information for account holder
  CreateIdInformation(applicationId, accountId, data) {
    return this.httpClient().post(
      `${this.endpoint}${applicationId}/account/${accountId}/id-info`,
      data
    );
  }
  UpdateIdInformation(applicationId, accountId, idId, data) {
    return this.httpClient().patch(
      `${this.endpoint}${applicationId}/account/${accountId}/id-info/${idId}`,
      data
    );
  }
  DeleteIdInformation(applicationId, accountId, idId) {
    return this.httpClient().delete(
      `${this.endpoint}${applicationId}/account/${accountId}/id-info/${idId}`
    );
  }

  // Address Information for account holder
  CreateAddressInformation(applicationId, accountId, data) {
    return this.httpClient().post(
      `${this.endpoint}${applicationId}/account/${accountId}/address`,
      data
    );
  }
  UpdateAddressInformation(applicationId, accountId, addressId, data) {
    return this.httpClient().patch(
      `${this.endpoint}${applicationId}/account/${accountId}/address/${addressId}`,
      data
    );
  }
  DeleteAddressInformation(applicationId, accountId, addressId) {
    return this.httpClient().delete(
      `${this.endpoint}${applicationId}/account/${accountId}/address/${addressId}`
    );
  }

  // Reference information for the account
  CreateReference(applicationId, accountId, data) {
    return this.httpClient().post(
      `${this.endpoint}${applicationId}/account/${accountId}/reference`,
      data
    );
  }
  UpdateReference(applicationId, accountId, referenceId, data) {
    return this.httpClient().patch(
      `${this.endpoint}${applicationId}/account/${accountId}/reference/${referenceId}`,
      data
    );
  }
  DeleteReference(applicationId, accountId, referenceId) {
    return this.httpClient().delete(
      `${this.endpoint}${applicationId}/account/${accountId}/reference/${referenceId}`
    );
  }

  // Documents for the account
  CreateDocument(applicationId, accountId, data) {
    return this.httpClient()({
      method: 'POST',
      url: `${this.endpoint}${applicationId}/account/${accountId}/document`,
      data: data,
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  }
  UpdateDocument(applicationId, accountId, documentId, data) {
    return this.httpClient().patch(
      `${this.endpoint}${applicationId}/account/${accountId}/document/${documentId}`,
      data
    );
  }
  DeleteDocument(applicationId, accountId, documentId) {
    return this.httpClient().delete(
      `${this.endpoint}${applicationId}/account/${accountId}/document/${documentId}`
    );
  }

  // Connected Person for the account
  CreateConnectedPerson(applicationId, accountId, data) {
    return this.httpClient().post(
      `${this.endpoint}${applicationId}/account/${accountId}/connected-person`,
      data
    );
  }
  UpdateConnectedPerson(applicationId, accountId, personId, data) {
    return this.httpClient().patch(
      `${this.endpoint}${applicationId}/account/${accountId}/connected-person/${personId}`,
      data
    );
  }
  DeleteConnectedPerson(applicationId, accountId, personId) {
    return this.httpClient().delete(
      `${this.endpoint}${applicationId}/account/${accountId}/connected-person/${personId}`
    );
  }

  // Employee details for the account
  CreateEmploymentInformation(applicationId, accountId, data) {
    return this.httpClient().post(
      `${this.endpoint}${applicationId}/account/${accountId}/employment-details`,
      data
    );
  }
  UpdateEmploymentInformation(applicationId, accountId, employmentId, data) {
    return this.httpClient().patch(
      `${this.endpoint}${applicationId}/account/${accountId}/employment-details/${employmentId}`,
      data
    );
  }
  DeleteEmploymentInformation(applicationId, accountId, employmentId) {
    return this.httpClient().delete(
      `${this.endpoint}${applicationId}/account/${accountId}/employment-details/${employmentId}`
    );
  }

  // Source of funds for the account
  CreateSourceOfFunds(applicationId, accountId, data) {
    return this.httpClient().post(
      `${this.endpoint}${applicationId}/account/${accountId}/source-of-funds`,
      data
    );
  }
  UpdateSourceOfFunds(applicationId, accountId, sourceId, data) {
    return this.httpClient().patch(
      `${this.endpoint}${applicationId}/account/${accountId}/source-of-funds/${sourceId}`,
      data
    );
  }
  DeleteSourceOfFunds(applicationId, accountId, sourceId) {
    return this.httpClient().delete(
      `${this.endpoint}${applicationId}/account/${accountId}/source-of-funds/${sourceId}`
    );
  }

  // Source of Wealth for the account
  createSourceOfWealth(applicationId, accountId, data) {
    return this.httpClient().post(
      `${this.endpoint}${applicationId}/account/${accountId}/source-of-wealth`,
      data
    );
  }
  updateSourceOfWealth(applicationId, accountId, sourceId, data) {
    return this.httpClient().patch(
      `${this.endpoint}${applicationId}/account/${accountId}/source-of-wealth/${sourceId}`,
      data
    );
  }
  DeleteSourceOfWealth(applicationId, accountId, sourceId) {
    return this.httpClient().delete(
      `${this.endpoint}${applicationId}/account/${accountId}/source-of-wealth/${sourceId}`
    );
  }

  // Beneficiary for the account
  CreateBeneficiary(applicationId, data) {
    return this.httpClient().post(
      `${this.endpoint}${applicationId}/beneficiary`,
      data
    );
  }
  UpdateBeneficiary(applicationId, beneficiaryId, data) {
    return this.httpClient().patch(
      `${this.endpoint}${applicationId}/beneficiary/${beneficiaryId}`,
      data
    );
  }
  DeleteBeneficiary(applicationId, beneficiaryId) {
    return this.httpClient().delete(
      `${this.endpoint}${applicationId}/beneficiary/${beneficiaryId}`
    );
  }

  // Product/Service for the account
  CreateProductOrService(applicationId, data) {
    return this.httpClient().post(
      `${this.endpoint}${applicationId}/service-product`,
      data
    );
  }
  UpdateProductOrService(applicationId, productId, data) {
    return this.httpClient().patch(
      `${this.endpoint}${applicationId}/service-product/${productId}`,
      data
    );
  }
  DeleteProductOrService(applicationId, productId) {
    return this.httpClient().delete(
      `${this.endpoint}${applicationId}/service-product/${productId}`
    );
  }
  AssignApplicationToUser(applicationId, assigneeName) {
    return this.httpClient().patch(
      `${this.endpoint}${applicationId}/assign/${assigneeName}`
    );
  }
  DeassignApplicationFromUser(applicationId) {
    return this.httpClient().patch(
      `${this.endpoint}${applicationId}/de-assign`
    );
  }
}
